import React, { useState } from "react";
import logo from "../../../Assets/images/user_square.png";
import styles from "./grid.module.css";
import style from "./grid1.module.css";

// import DriverModal from "../../Modals/DriverModal/DriverModal";

import { LazyLoadImage } from "react-lazy-load-image-component";

import FiltersComp from "../../Common/Filters/OrderFilters";
import PaginatorCom from "../../Paginator/PaginatorCom";
import DeliverymanDetails from "../../../Pages/Users/Drivers/DeliverymanDetails";

const DeliveryManGridTable = ({ isGrid, type, SetGridToggle, value ,fetchAllData,FilterData,handlePagination}) => {
  const [modal, setModal] = useState(false);
  const [itemData, setItemData] = useState("");
  const items =
    value && value.data && Array.isArray(value.data)
      ? value.data
      : [];
  // console.log("data in grid:", items);
  const handleItem = (item) => {
    setModal(true);
    setItemData(item);
  };
    // console.log('FileterData',FilterData);
    
    const onPaginatorClick = (e) => {
      if (e) {
        // console.log("Paginator Clicked",e);
       //  const row={
       //   filters: null,
       //   first: 0,
       //   multiSortMeta: [],
       //   page: 0,
       //   rows: 10,
       //   sortField: null,
       //   sortOrder: null,
       //   totalPages: 2   
       // }
       const data={
        limit:e.rows,
        page:+e.page+1
       }
       handlePagination && handlePagination(data)
       // handlePagination && handlePagination(e.row,limit,sortOrder,filter)
      }
    
    };

  // filter settings @started
   FilterData.filters=FilterData && FilterData?.filters.filter((f)=>FilterData?.disabledFilters?!FilterData?.disabledFilters.includes(f.inputName):true)
  // filter settings @end

  return (
    <>
     <div className={styles.main}>
        <FiltersComp
            layoutView={true}          
            gridToggle={isGrid}
            SetGridToggle={SetGridToggle}
            filters={FilterData?.filters ? FilterData?.filters : []}
            SearchBy={FilterData?.SearchBy?.options.length ? FilterData?.SearchBy : { options: [] }}
            WeekRange={FilterData?.WeekRange ? FilterData?.WeekRange : false}
            MonthRange={FilterData?.MonthRange ? FilterData?.MonthRange : false}
            canlenderFilter={FilterData?.canlenderFilter}
            handleFilter={(name, value) =>
              FilterData?.handleFilter && FilterData?.handleFilter(name, value)
            }
            handleClearFilter={() => FilterData?.handleClearFilter && FilterData?.handleClearFilter()}
            handleSearch={FilterData?.handleSearch ? FilterData?.handleSearch : null}
            actionButton={
              FilterData?.button_name &&
              FilterData?.handleButton && {
                button_name: FilterData?.button_name,
                handleButton: FilterData?.handleButton,
              }
            }
          />
      <div className={!isGrid ? "" : style.gridContainer}>
          
       
        {items.length > 0 ? (
          items.map((item, index) => (
            <div style={{ padding: "0.5rem" }} onClick={() => handleItem(item)}>
              <div
                className={!isGrid ? styles.sub_container : style.sub_container}
              >
                {item.profile_image ? (
                  <LazyLoadImage
                    src={item.profile_image}
                    alt="img"
                    loading="lazy"
                    effect="blur"
                    wrapperProps={{
                      style: { transitionDelay: "1s" },
                    }}
                    className={!isGrid ? styles.img : style.img}
                  />
                ) : (
                  <img
                    src={logo}
                    alt=""
                    className={!isGrid ? styles.img : style.img}
                  />
                )}  

                <div
                  className={
                    !isGrid ? styles.sub_sub_container : style.sub_sub_container
                  }
                >
                  <div>
                    <p className="flex">
                      <span>
                        {item.firstName || ""}
                        {item.lastName || ""}
                      </span>
                    </p>
                    <span>{item.gender || ""}</span>
                  </div>

                  <div>
                    <p>{item.email || ""}</p>
                    <span>{item.phone_number || ""}</span>
                  </div>

                  <div className={styles.price_Add}>
                    {/* <div>Rs: 0 INR</div> */}
                    <div>{item.address || "address"} </div>
                  </div>
                  {item.delivery_business?.name ? (
                    <span className={styles.resto_span}>
                      {item.delivery_business?.name}
                    </span>
                  ) : (
                    <span className={styles.resto_span}>Delivery Man</span>
                  )}
                </div>
              </div>
              
            </div>
          ))
        ) : (
          <p>No data available</p>
        )}
        <PaginatorCom
          paginatorData={{
            filters: null,
            first: 0,
            multiSortMeta: [],
            page: value?.data?.page||1,
            rows: value?.data?.limit||5,
            sortField: null,
            sortOrder: null,
            totalPages: value.data?.totalPages||1  ,
            totalCount: value.data?.totalCount||1  
          }}
          onPaginatorClick={onPaginatorClick}
        />
      </div>
      

     
      {modal && type === "drivers" && (
        <DeliverymanDetails
          data={itemData}
          setModal={setModal}
          modal={modal}
        />
      )}
  
      </div>
    </>
  );
};

export default DeliveryManGridTable;
